import styled from "styled-components";
import { colors } from "./";

export const opacityNotSelected = 0.2;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  width: 100%;
  padding: 20px;
`;

export const Button = styled.button`
  width: 100px;
  height: 36px;
  border-radius: 3px;
  font-weight: bold;
  font-size: 14px;
  color: ${colors.white};
  background-color: ${colors.gray};
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  border: none;
  margin: 0;
  cursor: pointer;
  text-transform: uppercase;
`;

export const Label = styled.label`
  font-weight: bold;
  text-transform: uppercase;
`;

export const Input = styled.input`
  display: none;
  & + label {
    cursor: pointer;
  }
`;
